import { USPS_SUFFIXES } from '../../../../constants';
import template from './suffix-select.html';
import './suffix-select.global.css';

class SuffixSelectController {
  $onInit() {
    this._options = USPS_SUFFIXES.concat();
  }

  get options() {
    return this._options;
  }

  get showingPlaceholder() {
    return this.ngModel === '' || this._options.indexOf(this.ngModel) === -1;
  }
}

export const SuffixSelectComponent = {
  bindings: {
    placeholder: '@',
    ngModel: '=',
    ariaLabel: '@',
    ariaDescribedby: '@',
  },
  controller: SuffixSelectController,
  template,
};
